import {
	Box,
	Button,
	Card,
	CardContent,
	Container,
	Grid,
	Link,
	Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { TypographyH2 } from "./style";
import logic from "./logic";
import BTTextInput from "src/components/BTTextInput";
import BTCheckBox from "src/components/BTCheckBox";

const Login: React.FC<{}> = () => {
	const { isLoading, control, handleSubmit, onSubmit } = logic();

	return (
		<Container maxWidth="xs" sx={{ textAlign: "center" }}>
			<Grid justifyContent="center" alignItems="center" container>
				<Grid item xs={12}>
					<TypographyH2 sx={{ mb: 2 }} variant="h2">
						Login
					</TypographyH2>
				</Grid>
				<Box
					component="form"
					sx={{ "& .MuiTextField-root": { m: 1, width: "25ch" } }}
					onSubmit={handleSubmit(onSubmit)}
					noValidate
					autoComplete="off"
				>
					<Grid
						container
						direction="row"
						justifyContent="center"
						alignItems="stretch"
						spacing={3}
					>
						<Grid item xs={12}>
							<Card>
								<CardContent>
									<div>
										<BTTextInput
											name="USERNAME"
											label="EPF No / Mobile No"
											control={control}
										/>
									</div>
									<div>
										<BTTextInput
											name="USERPWD"
											label="Password"
											type="password"
											control={control}
										/>
									</div>
									<BTCheckBox
										name="REMEMBER"
										label="Remember me"
										control={control}
									/>
									<Button
										size="large"
										variant="contained"
										type="submit"
										disabled={isLoading}
									>
										Login
									</Button>
									<Button
										component={RouterLink}
										to="/register"
										size="large"
										variant="text"
									>
										Register
									</Button>
								</CardContent>
							</Card>
							<Button
								component={RouterLink}
								to="/pwdforget"
								size="large"
								variant="text"
							>
								Forget Password?
							</Button>
							<Typography sx={{ pt: { xs: 2, md: 0 } }} variant="subtitle1">
								Crafted by{" "}
								<Link
									href="http://bluetechsoftwares.com"
									target="_blank"
									rel="noopener noreferrer"
								>
									bluetechsoftwares.com
								</Link>
							</Typography>
						</Grid>
					</Grid>
				</Box>
			</Grid>
		</Container>
	);
};

export default Login;
